var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 178.32837,
    viewBox: "0 0 1588 505",
    width: 560.763271,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m260.6 497.3h-111v-395.9h-149.6v-93.7h411v93.7h-150.4zm629.3-193h-222.7v193h-111v-489.6h111v204.2h222.7v-204.2h111v489.6h-111zm572.4-193q-35.9-14.7-71.7-14.7-42.9 0-78.3 20.6-35.5 20.7-55.9 56-20.4 35.3-20.4 78.7.1 43.3 20.8 79.3 20.7 36.1 56.2 56.7 35.4 20.6 78.3 20.6 21.8 0 47.1-7.3 25.3-7.4 49.1-19.9v-130.8h96.3v190.2q-39.4 28.7-94.2 46.5-54.7 17.9-105.3 17.9-73.8 0-133.5-33.3-59.7-33.2-94.1-90.9-34.5-57.7-34.5-129 0-70.7 35.2-128.4 35.1-57.7 96.6-90.6 61.4-32.8 136.6-32.8 54.8 0 107.1 19.5 52.4 19.6 90.3 53.2l-62.5 79q-27.4-25.8-63.2-40.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThgLogo);
export default __webpack_public_path__ + "static/media/thg-logo.452c766b3884b51b601799d567b88fe9.svg";
export { ForwardRef as ReactComponent };